const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/delivery/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { requireCapabilities } from '@/features/authentication/lib/routeGuards';
import { createFileRoute } from '@tanstack/react-router';

/**
 * Layout route for the `/delivery` section (customer Delivery management). Gated
 * in `beforeLoad` by the admin-only exact `deliveries` domain capability. The
 * delivery list endpoint (`GET /deliveries`) is
 * itself `.manage`-gated; callers without admin access are redirected to
 * `/forbidden` and no child page mounts. The delivery list lives in a secondary rail
 * `<Outlet />`; `SectionShell` presents that same list at the mobile section root,
 * mirroring `/raw-footage`.
 */
export const Route = createFileRoute('/_authenticated/_app/delivery')({
  beforeLoad: requireCapabilities(has => has('deliveries.manage')),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});